import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_nx4b2n7mpy: FaireCollectionEntity = {
  token: "pbc_nx4b2n7mpy",
  type: "collection",
  name: "Best Selling Restocks",
  heroImageUrl:
    "https://cdn.faire.com/fastly/402bfa363f4f6b521328e0327943dd47df227a0ce427e20ea33a562d2d33a66f.jpeg",
  itemCount: 110,
  description:
    "Our top-rated faves are back! Shop the ultimate Judy Blue restocks in regular and plus sizes.",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:14.621Z",
    importedBy: "entity-db-import-collections",
  },
};
